import React from 'react';

const InfoBanner = ({ message }) => {
    return <div className="refillplans__banner">{message}</div>;
};

export default InfoBanner;
